import { useEffect } from 'react';
import type { HomeBuildFocusId } from '../lib/generation-intent';
import { useCanvasSession } from '../contexts/CanvasSessionContext';

export const GENERATION_INTENT_EVENT = 'landi-canvas-generation-intent';

export interface GenerationIntentEventDetail {
  path: string;
  query: string;
  focus: HomeBuildFocusId;
}

/** Wires home submit → durable canvas session spine (Stage 06). */
export function useGenerationIntentListener(): void {
  const { startFromIntent } = useCanvasSession();

  useEffect(() => {
    const handler = (event: Event): void => {
      const custom = event as CustomEvent<GenerationIntentEventDetail>;
      const detail = custom.detail;
      if (!detail?.query?.trim()) return;
      void startFromIntent({ query: detail.query, focus: detail.focus });
    };

    window.addEventListener(GENERATION_INTENT_EVENT, handler);
    return () => window.removeEventListener(GENERATION_INTENT_EVENT, handler);
  }, [startFromIntent]);
}
